"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _button = require("@creditas-lab/button");

var _stylitas = require("@creditas/stylitas");

const StyledButton = (0, _stylitas.styled)(_button.Button)`
  padding: 0;
  min-width: 0;
  border: none;
  width: auto;
  height: auto;

  &:hover {
    background: none;
    border: none;
  }
`;
exports.Button = StyledButton;